export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/74cc88c7571ddfe8037db442e45677ad.svg";